import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var VariantsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default VariantsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Variants/VariantsReduxProps.ts
// module id = 509
// module chunks = 0